import { render } from "./ExperienceMentor.vue?vue&type=template&id=031a0f87"
import script from "./ExperienceMentor.vue?vue&type=script&lang=js"
export * from "./ExperienceMentor.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__